import { useContext } from "react";

import { SupportUserIdContext } from "@/context/SupportUserId";

export function useSupportUserId(): string {
    return useContext(SupportUserIdContext);
}
